import { memo } from 'react';

import { Fields } from '@air/next-icons';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

export type CustomFieldsButtonProps = {
  options: DropdownMenuOption[];
};

export const CustomFieldsButton = memo(({ options }: CustomFieldsButtonProps) => (
  <DropdownMenu
    trigger={
      <IconButton
        label="Edit Custom Fields"
        appearance="ghost"
        color="grey"
        className="ui2:rounded-4 text-grey-1 hover:text-grey-10 active:text-grey-9"
        size="small"
      >
        <Fields className="size-4" />
      </IconButton>
    }
  >
    {renderDropdownItems({ options })}
  </DropdownMenu>
));

CustomFieldsButton.displayName = 'CustomFieldsButton';
